import { atom } from 'jotai'

export const isVisibleLoadDialogAtom = atom(false)
export const isVisibleSaveDialogAtom = atom(false)
